module.exports = __webpack_public_path__ + "img/003-puzzle.87ba894a.svg";